import axios from 'axios';
import { from } from 'rxjs';

export const postCustomerImportCsv = (ignoreCsvRecord, file) => {
  const formData = new FormData();
  formData.append('CsvFile', file);
  formData.append('delimitertype', 'csv');
  formData.append('IgnoreMatch', ignoreCsvRecord);

  const postFile = axios.post('/customer/start-import', formData, {
    headers: {
      ContentType: 'multipart/form-data',
    },
  });
  const data$ = from(postFile);
  return data$;
};

export const postImportLog = (batchId) => {
  const request = axios.post('/customer/import-log', { batchId });
  const data$ = from(request);
  return data$;
};
